// modules
import { lazy, Suspense } from 'react'

// components
import Spin from 'antd/es/spin'

const LazyImport = (ImportedComponent: any) => {
  const Component = lazy(ImportedComponent)

  return (props: any) => (
    <Suspense fallback={<Spin className="spinner" size="large" />}>
      <Component {...props} />
    </Suspense>
  )
}

export default LazyImport
